import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StyleClassModule } from 'primeng/styleclass';
import { TagModule } from 'primeng/tag';
import { PanelModule } from 'primeng/panel';

import { CalendarModule } from 'primeng/calendar';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';

import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';
import { BadgeModule } from 'primeng/badge';
import { PickListModule } from 'primeng/picklist';
import { FileUploadModule } from 'primeng/fileupload';
import { ScrollerModule } from 'primeng/scroller';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MenuModule } from 'primeng/menu';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SkeletonModule } from 'primeng/skeleton';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StyleClassModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    KeyFilterModule,
    DropdownModule,
    AutoCompleteModule,
    PanelModule,
    TableModule,
    PaginatorModule,
    TooltipModule,
    BadgeModule,
    TagModule,
    CalendarModule,
    PickListModule,
    PanelModule,
    FileUploadModule,
    ScrollerModule,
    ScrollPanelModule,
    ConfirmDialogModule,
    ButtonModule,
    MenuModule,
    CheckboxModule,
    RadioButtonModule,
    SkeletonModule
  ],
  exports: [
    StyleClassModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    KeyFilterModule,
    DropdownModule,
    AutoCompleteModule,
    PanelModule,
    TableModule,
    PaginatorModule,
    TooltipModule,
    BadgeModule,
    TagModule,
    CalendarModule,
    PickListModule,
    PanelModule,
    FileUploadModule,
    ScrollerModule,
    ScrollPanelModule,
    ConfirmDialogModule,
    ButtonModule,
    MenuModule,
    CheckboxModule,
    RadioButtonModule,
    SkeletonModule
  ],
})
export class PrimengModule {}
